export const app = {
    init: function() {
        $('.menu-btn').on('click', app.menuToggle);
        $('#menu-btn').on('click', app.mobileMenuToggle);
        $('.subnav-btn').on('click', app.subnavToggle);
        $('.tab-btn').on('click', app.tabsToggle);
        $('.tags .btn i').on('click', app.removeTag);
        $('.file-nest input').on('change', app.imagePreview);
    },
    menuToggle: function() {
        const self = $(this);
        const elems = $('header, main');
        self.toggleClass('active');
        elems.toggleClass('minimise');
    },
    mobileMenuToggle: function() {
        const self = $(this);
        const menu = $('nav');
        self.toggleClass('active');
        menu.slideToggle(200);
    },
    subnavToggle: function() {
        const self = $(this);
        const par = self.parents('li:not(.opened)');
        const subnav = par.find('ul');
        const subnavs = $('nav ul ul');
        const other = $('nav li').not(par);
        other.removeClass('opened');
        par.toggleClass('opened');
        subnavs.not(subnav).slideUp(200);
        subnav.slideToggle(200);
    },
    tabsToggle: function() {
        const self = $(this);
        const par = self.parents('.tabs-menu');
        const btns = par.find('.tab-btn');
        const tab = $(self.data('tab'));
        const tabs = tab.parents('.tabs').find('.tab');
        btns.removeClass('active');
        self.addClass('active');
        tabs.hide();
        tab.show();
    },
    imagePreview: function() {
        const ctx = this;
        const self = $(this);
        const field = self.parents('.file-nest');
        const preview = field.find('img');

        if (ctx.files && ctx.files[0]) {
            const reader = new FileReader();
            reader.onload = function(e) {
                field.find('.filename').text(ctx.files[0].name);
                preview.prop('src', e.target.result);
            }
            reader.onloadend = function() {}
            reader.readAsDataURL(ctx.files[0]);
        }
    }
}